import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import FormDrawerWrapper from '../../../../features/components/FormDrawerWrapper'
import UploadRequestedFilesForm from './UploadRequestedFilesForm'
import WarningMessage from '../../../../features/components/Form/WarningMessage'

import useManageFormsDrawer from '../../../../hooks/formHooks/useManageFormsDrawer'

import { createJsonFromQueryString } from '../../../../helpers/url'
import {
  getMediaOrderRequestedFilesWasLoadedSelector,
  mediaOrderRequestedFilesSelector
} from '../../../../modules/selectors/mediaOrdersBookings'

import { UPLOAD_BOOKED_MEDIA_FILES } from '../../../../constants/forms'

import useStyles from './styles'

function UploadRequestedFiles() {
  const classes = useStyles()

  const mediaOrderRequestedFiles = useSelector(mediaOrderRequestedFilesSelector)
  const mediaOrderRequestedFilesWasLoaded = useSelector(getMediaOrderRequestedFilesWasLoadedSelector)
  const { mediaId, customDate } = createJsonFromQueryString(window.location.search)
  const { selectedEditItemId } = useManageFormsDrawer({
    formName: UPLOAD_BOOKED_MEDIA_FILES
  })

  const selectedFileId = Number(selectedEditItemId)

  const selectedFileMediaData = useMemo(
    () =>
      mediaOrderRequestedFiles.find(
        ({ requested_file }) =>
          requested_file.id === Number(selectedFileId) && requested_file.booked_media_id === Number(mediaId)
      ),
    [mediaId, mediaOrderRequestedFiles, selectedFileId]
  )

  return (
    <FormDrawerWrapper
      formName={UPLOAD_BOOKED_MEDIA_FILES}
      showOpenButton={false}
      hasDefaultDrawerContentSpacing={false}
      isFormLoading={!mediaOrderRequestedFilesWasLoaded}
      isWideDrawer
    >
      {selectedFileMediaData ? (
        <UploadRequestedFilesForm
          selectedFileMediaData={selectedFileMediaData}
          selectedFileId={selectedFileId}
          customDate={customDate}
        />
      ) : (
        <WarningMessage
          description="Requested file was not found"
          sectionClassName={classes.warningMessageSection}
          descriptionClassName={classes.warningMessageDescription}
        />
      )}
    </FormDrawerWrapper>
  )
}

export default UploadRequestedFiles
